import { useToast } from "primevue/usetoast";
import { useLanguage } from "src/composables/useLanguage";

interface NotificationOptions {
  entity?: string;
  message?: string;
  duration?: number;
  error?: Error;
}

export function useNotification() {
  const toast = useToast();
  const { translate } = useLanguage();

  function showToast({ message, duration = 3000 }: NotificationOptions, severity: string, defaultKey: string) {
    toast.add({
      severity,
      summary: translate(defaultKey),
      detail: message || translate(defaultKey),
      life: duration,
    });
  }

  function showSuccess(options: NotificationOptions = {}) {
    return showToast(options, "success", "success");
  }

  function showError(options: NotificationOptions = {}) {
    return showToast(options, "error", "error");
  }

  function showInfo(options: NotificationOptions = {}) {
    return showToast(options, "info", "info");
  }

  function showWarning(options: NotificationOptions = {}) {
    return showToast(options, "warn", "warning");
  }

  return {
    showSuccess,
    showError,
    showInfo,
    showWarning,
  };
}
